import React, { useMemo, useState } from 'react'
import logo from 'meinian-package/src/image/logo_icon.png'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import { ossImg } from 'meinian-package/src/utils/image'
import css from './index.module.less'
import MoreFolderBtn from '../moreFolderBtn'
import { useSetTop, useUnsetTop } from '../../hooks/useTop'
import CardInfo from './cardInfo'

type Folder = {
  coverUrl?:string
  lastImageUrl?:string[]
  folderName?:string
  sampleClothingNum?:number
  userName?:string
  topFlag?:number
  id?:number
}
type Props= {
  lastImageUrl:string[]
  sampleClothingNum:number
  userName:string
  id:number
  topFlag:number
  columnWidth:number
  onRefresh?:()=>void
}
function PlaceholderImage({ className }:any) {
  return <div className={classNames(css.placeholderImage, className)}><img src={logo} alt="" /></div>
}
function Image(props:{src:string, className?:any}) {
  if (props.src) {
    return <img className={props.className} src={props.src} alt="" />
  }
  return <PlaceholderImage className={props.className} />
}
/**
 * 样衣文件夹卡片
 */
export default function FolderCard(props:Props) {
  const navigate = useNavigate()
  const [editItem, setEditItem] = useState<Folder>({})
  const { onRefresh, id, lastImageUrl, topFlag, columnWidth, sampleClothingNum, userName } = props
  const coverHeight = 0.6 * columnWidth
  const onSetTop = useSetTop(onRefresh)
  const onUnsetTop = useUnsetTop(onRefresh)

  const item = useMemo(() => {
    return { ...props, ...editItem }
  }, [props, editItem])
  return <section onClick={() => navigate(`/home/sample/${id}`)} className={css.card} style={{ width: columnWidth, height: coverHeight + 80 }}>
    <div className={css.images}>
      <div className={css.cover} style={{ height: coverHeight }}>
        <Image src={ossImg(item.coverUrl, 600, 600)} className={css.mainImage} />
      </div>
      <div className={css.col} style={{ height: coverHeight }}>
        <Image src={ossImg(lastImageUrl[0], 600, 600)} className={css.recentImg1} />
        <Image src={ossImg(lastImageUrl[1], 600, 600)} className={css.recentImg2} />
      </div>
      <div className={css.mask}>
        <div
          className={css.button}
          onClick={(e) => {
            e.stopPropagation()
            topFlag !== 1 ? onSetTop(id) : onUnsetTop(id)
          }}
        >
          {topFlag ? '取消置顶' : '置顶'}
        </div>
        <MoreFolderBtn
          data={props}
          onUpdate={(updateValue) => {
            setEditItem({ ...editItem, ...updateValue })
          }}
          onDataChange={onRefresh}
          parent={undefined}
          className={css.moreFolderBtn}
        />
      </div>
    </div>
    <CardInfo
      name={item.folderName}
      userName={userName}
      num={sampleClothingNum}
    />
  </section>
}
